import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import OfferCard from "../offerPage/offerCard2";

const MOCK_GOLD_OFFERS = [
  { _id: "mock-gold-muthoot", lender_id: "mock-muthoot", lender_name: "Muthoot", banking_partners_hl: "https://campaigns.digitmoney.in/image/partners/muthoot.png", credit_limit: 800000, emi: 17240, tenure: 60, interest_rate: "10.75% p.a.", app_url: "#" },
  { _id: "mock-gold-iifl", lender_id: "mock-iifl", lender_name: "IIFL Finance", banking_partners_hl: "https://campaigns.digitmoney.in/image/partners/iifl.png", credit_limit: 750000, emi: 16820, tenure: 60, interest_rate: "11.00% p.a.", app_url: "#" },
  //{ _id: "mock-gold-manipal", lender_id: "mock-manipal", lender_name: "Manipal Fintech", banking_partners_hl: "https://campaigns.digitmoney.in/image/partners/manipal.png", credit_limit: 600000, emi: 13100, tenure: 60, interest_rate: "12.00% p.a.", app_url: "#" },
];

const NotEligibleOfferPage = ({ setCurrentStep, setSelectedOffer }) => {
  const aaSlice = useSelector((state) => state?.aa);
  const InternalLeadId = aaSlice?.internalLeadId;
  // Gold offers come from the same offer store as PL. When routed here (no PL
  // offer), redux holds the gold successes. Fall back to mock only for the
  // standalone dev preview (?ui=gold) when redux is empty.
  const offersData = useSelector((state) => state.app.allOffers);
  const reduxOffers = Array.isArray(offersData)
    ? offersData.flatMap((item) => item.offers || [])
    : offersData?.offers || [];
  const isGoldPreview =
    typeof window !== "undefined" &&
    new URLSearchParams(window.location.search).get("ui") === "gold";

  const offers = reduxOffers.length
    ? reduxOffers
    : isGoldPreview
    ? MOCK_GOLD_OFFERS.map((o) => ({ ...o, lead_id: InternalLeadId }))
    : [];

  const hasOffers = offers.length > 0;

  return (
    <div className="dm-not-eligible-v9 w-full max-w-[400px] mx-auto bg-white min-h-screen px-4 pb-[120px] font-atkinson">
      {/* Header */}
      <h1 className="font-bold text-[22px] leading-[1.14] tracking-[-0.01em] mt-6 text-[#1b1b1b] text-center">
        <span className="text-[#ff7a1a]">Sorry!</span> You are not eligible
      </h1>
      <p className="text-[13px] leading-[1.4] text-[#8b8b8b] mt-3 text-center">
        You don't currently qualify for Personal Loan offers based on our partner lenders' eligibility
        criteria.
      </p>

      {!hasOffers && (
        <div className="bg-white rounded-[24px] border border-[#ededed] mt-8 px-6 py-8 text-center w-full">
          <p className="text-[16px] font-bold text-[#1b1b1b]">
            We currently have no pre-approved offers available for you.
            <br/>Please check back later.
            <br/>Stay connected for exciting offers!
          </p>
        </div>
      )}

      {/* Gold Loan promo */}
      {hasOffers && (
      <div className="flex items-start gap-3 bg-[#fdf6e3] border border-[#e7c66b] rounded-[20px] p-4 mt-6">
        <img src={process.env.PUBLIC_URL + "/assets/img/goldbricks.png"} alt="" className="w-[84px] h-auto flex-none object-contain" />
        <div>
          <p className="font-bold text-[15px] leading-[1.2] text-[#1b1b1b]">
            But here's some good news!
          </p>
          <p className="text-[11px] leading-[1.4] text-[#3a3a3a] mt-2">
            You qualify for <b className="text-[#c79216]">Gold Loan offers</b> from {offers.length} trusted lender{offers.length === 1 ? "" : "s"}.
            Your offers are ready to compare with faster approval chances.
          </p>
        </div>
      </div>
      )}

      {/* Reassurance pill */}
      {hasOffers && (
      <div className="flex items-center justify-center gap-2 bg-[#d7f7e6] text-[#0b7a55] text-[11px] leading-[1.25] rounded-full px-4 py-3 mt-4">
        ⏱ Most customers complete the next step in under 3 minutes.
      </div>
      )}

      {/* Gold Loan offer cards */}
      <div>
        {offers.map((offer) => (
          <OfferCard
            key={offer._id}
            offer={offer}
            setCurrentStep={setCurrentStep}
            setSelectedOffer={setSelectedOffer}
          />
        ))}
      </div>

      {/* Disclaimer — sticky footer (matches the PL offer page) */}
      <div className="fixed bottom-0 left-0 right-0 z-40">
        <div className="max-w-[400px] mx-auto bg-white px-4 pt-3 pb-4 border-t border-[#f0f0f0]">
          <p className="text-left italic text-[#b3b3b3] text-[12px] leading-[15px] font-atkinson">
            <b className="not-italic">Disclaimer:</b> These offers are subject to change at discretion of
            Bank / NBFC after receiving all your documents and details. Final offer will be based on risk
            policy of Bank / NBFC. We do not guarantee that final offer will be same as Pre-approved offer.
            <br />
            <b className="not-italic">Note:</b> You may receive calls from multiple lenders.
          </p>
        </div>
      </div>
    </div>
  );
};

export default NotEligibleOfferPage;